import { useEffect, useState } from "react";
import useDataBean from "../../../../../core/services/dataBean/useDataBean";
import { Singleton } from "../../../../../core/services/Singleton";
import { toast } from "react-toastify";
import { ListMenu } from "../../../../theme/Component/ListMenu";
import { BasicPage } from "../../../../theme/Component/BasicPage";
import { BasicTable } from "../../../../theme/Component/BasicTable";
import { Modal } from "../../../../theme/Component/Modal";
import { ModalConfirm } from "../../../../theme/Component/ModalConfirm";
import { YearSelector } from "../../../../../core/shared/inputs/YearSelector";
import { _DocumentFactory, _single } from "../../../../../core/services/dataBean/EntityCatalog";
import { OfficeEditor } from "../../Office/OfficeEditor";
import { _CashDeskAccountCDP } from "../../../../../core/services/dataBean/EntityCatalogVdos";
import { CashDeskAccountSelector } from "../CashDeskAccountSelector";
import { CompanyEditor } from "../../Company/CompanyEditor";
import { BasicButton } from "../../../../theme/Component/BasicButton";
import { CDPsEditor } from "../../../../contabilidad/budgetRPFactory/CDPsEditor";
import { CashDeskAccountCDPCertificate } from "./CashDeskAccountCDPCertificate";
import { DocumentViewer } from "../../../../theme/Component/DocumentViewer";




export const CashDeskAccountCDP = () => {

    const cashdeskaccountcdp = useDataBean(_CashDeskAccountCDP);
    const single = Singleton.getInstance();
    const [lista, setLista] = useState<any>([]);
    const [docs, setDocs] = useState<any>([]);
    const _documentos = useDataBean(_DocumentFactory);
    const [viewcdp, setviewcdp] = useState<any>({ name: 'Ver Documento', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-xl' });
    const [certificate, setcertificate] = useState<any>({ name: 'Ver Documento', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modal, setModal] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [modalC, setModalC] = useState<any>({ name: 'Editar', tabIndex: -1, view: false, btnClose: true, btnSubmit: true, format: 'modal-lg' });
    const [form, setForm] = useState<any>({
        Office: NaN,
        Year: _single.getCurrenYear(),
        IDCashDeskAccount: NaN,

    })
    useEffect(() => {

    }, [])
    useEffect(() => {
        if (viewcdp.view) {
            verDocumentos();
        }
    }, [viewcdp.view]);
    const getLista = () => {

        cashdeskaccountcdp.instance.getCashDeskAccountCDPCatalog(form.Year, form.IDCashDeskAccount).then(
            (resp: any) => {
                if (resp) {
                    setLista(resp)
                    //console.log(resp)
                }
            }
        )

    }

    const create = () => {
        cashdeskaccountcdp.setBean({
            IDCashDeskAccount: cashdeskaccountcdp.bean.IDCashDeskAccount,
        });
        setModal({ ...modal, "view": true });
    }
    const deleteItem = () => {
        cashdeskaccountcdp.deleteItemVoid(cashdeskaccountcdp.bean.IDCashDeskAccountCDP).then(
            (resp: any) => {
                getLista();
                setModalC({ ...modalC, "name": `Eliminar`, "view": false });
            }
        )

    }
    const editaItem = () => {
        //console.log(BankingEntity.bean);
        cashdeskaccountcdp.instance.addCDPDocumentToCashDeskAccount(cashdeskaccountcdp.bean.IDCashDeskAccount, cashdeskaccountcdp.bean.DocumentLocation.IDDocument, cashdeskaccountcdp.bean.DocumentLocation.DocumentDate).then(
            (resp: any) => {
                getLista();
                setModal({ ...modal, "view": false });
            }
        ).catch(err => {
            toast.error(err);
        })

    }

    const head = [
        { title: 'ID', property: 'IDCashDeskAccountCDP', visible: true },
        { title: 'Año', property: 'Year', visible: true },
        { title: 'Fecha del Documento', property: 'DocumentDate', visible: true },
        { title: 'Número Documento', property: 'Mnemonic', visible: true },
        { title: 'Número Consecutivo', property: 'Consecutive', visible: true },
        { title: 'Valor del CDP', property: 'CDPValue', visible: true },
        { title: 'Valor por Comprometer', property: 'RPValue', visible: true },
        { title: 'Disponible', property: 'LeftValue', visible: true },
        { title: 'Porcentaje de Uso', property: 'Percent', visible: true },




    ]

    const iconButtonsItem = [
        { nombre: 'Agregar', visible: single.canCreate(), icono: 'ri-file-add-line', evento: create }
    ]
    const listaBotones = () => {
        const botones = [

            { titulo: 'Ver Certificado de Disponibilidad Presupuestal', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setcertificate({ ...certificate, "view": true }) } },
            { titulo: 'Consultar / Ver Documento ', icono: 'ri-edit-2-line', visible: single.canEdit(), evento: () => { setviewcdp({ ...viewcdp, "view": true }) } },
            { titulo: 'Eliminar', icono: 'ri-delete-bin-line', visible: single.canDelete(), evento: () => { setModalC({ ...modalC, "view": true }) } },

        ]
        return (
            <ListMenu listaBotones={botones} />
        )
    }
    const verDocumentos = () => {

        if (cashdeskaccountcdp.bean.IDDocument && cashdeskaccountcdp.bean.DocumentDate) {
            _documentos.instance.getPdfAccountantDocument(cashdeskaccountcdp.bean.IDDocument, null, cashdeskaccountcdp.bean.DocumentDate, _single.getAccountID()).then(
                (resp: any) => {
                    console.log(resp);
                    setDocs(resp.DocumentURL);
                }
            )
        } else {
            toast.warning("No hay documento asociado");
        }

    }

    return (
        <BasicPage titulo="Certificados de Disponibilidad Presupuestal de Cajas Menores">
            <div className="row">
                <div className="col-md-4">

                    <YearSelector value={form.Year} tittle="Año" onChange={(e) => { setForm({ ...form, "Year": e }) }} />
                </div>
                <div className="col-md-4">
                    <CompanyEditor id={form.IDCompany} onchange={(e: any) => { setForm({ ...form, "IDCompany": e }) }}></CompanyEditor>
                </div>
                <div className="col-md-4">
                    <OfficeEditor id={form.Office} onchange={(e) => { setForm({ ...form, "Office": e }) }} />
                </div>
                <div className="col-md-4">
                    <CashDeskAccountSelector label='Cajas Menores' id={form.IDCashDeskAccount} onchange={(e) => { setForm({ ...form, "IDCashDeskAccount": e }) }} />
                </div>
                <div className="col-md-4 mt-4">
                    <BasicButton icon="ri-send-plane-fill" eventClick={getLista}>Buscar</BasicButton>
                </div>

            </div>
            <div className="row">
                <div className="col-md-12">

                    <BasicTable body={lista} head={head} rowSet={cashdeskaccountcdp.setBean} listButtons={listaBotones()} iconButtons={iconButtonsItem}></BasicTable>
                    <Modal modal={modal} updateModal={setModal} eventModal={editaItem}>
                        <div className="row">


                            <div className="col-md-6"> <OfficeEditor id={form.Office} onchange={(e) => { setForm({ ...form, "Office": e }) }} /> </div>
                            <div className="col-md-6">
                                <CashDeskAccountSelector label='Cajas Menores' id={cashdeskaccountcdp.bean.IDCashDeskAccount} onchange={(e) => { cashdeskaccountcdp.setBean({ ...cashdeskaccountcdp.bean, "IDCashDeskAccount": e }) }} />
                            </div>
                            <div className="col-md-12">
                                <CDPsEditor label="CDP / RP" value={cashdeskaccountcdp.bean.IDDocument} onChange={(e) => { cashdeskaccountcdp.setBean({ ...cashdeskaccountcdp.bean, "IDDocument": e.IDDocument, "DocumentLocation": e }) }} />
                                    
                            </div>

                        </div>
                    </Modal>
                    <Modal modal={certificate} updateModal={setcertificate}>
                        <CashDeskAccountCDPCertificate CashDeskAccountCDPIDDocument={cashdeskaccountcdp.bean} />
                    </Modal>
                    <Modal modal={viewcdp} updateModal={setviewcdp}>
                        <>

                            <div className="row">
                                <div className="col-md-12">
                                    <DocumentViewer
                                        list={docs}
                                        IDDocument={cashdeskaccountcdp.bean.IDDocument}
                                        Since={cashdeskaccountcdp.bean.DocumentDate}
                                    />
                                </div>
                            </div>
                        </>
                    </Modal>
                    <ModalConfirm modal={modalC} updateModal={setModalC} eventModal={deleteItem}>
                        <strong>Eliminar item</strong>
                    </ModalConfirm>
                </div>

            </div>
        </BasicPage>
    )
}